import styled from '@emotion/styled';

export const StyledProcedureUnorderedList = styled.ul`
  margin: 5px 0px;
  padding-inline-start: 20px;
`;

export const StyledProcedureOrderedList = styled.ol`
  margin: 7px 0px;
  padding-inline-start: 23px;
`;

export const StyledProcedureItem = styled.li<{ color: string }>`
  margin: 0px;
  padding-inline-start: 6px;
  ::marker {
    color: ${({ color }) => color};
  }
`;

export const StyledSequenceNumberItem = styled.li<{
  color: string;
  isMarkerBold: boolean;
}>`
  margin: 0px;
  padding-inline-start: 2px;
  ::marker {
    ${({ isMarkerBold }) => isMarkerBold && 'font-weight: bold;'}
    color: ${({ color }) => color};
  }
`;

export const StyledTermsOfUseList = styled.ul``;

export const StyledTermsOfUseListItem = styled.li``;
